import React, { Suspense, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useRoute } from '../../contexts/RouteContext';
import RouteLoadingSpinner from '../Common/RouteLoadingSpinner';

interface LazyRouteWrapperProps {
  children: React.ReactNode;
}

const LazyRouteWrapper: React.FC<LazyRouteWrapperProps> = ({ children }) => {
  const { updateRouteParams } = useRoute();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      updateRouteParams(id);
    } else {
      updateRouteParams('');
    }
  }, [id, updateRouteParams]);

  return (
    <Suspense fallback={<RouteLoadingSpinner />}>
      {children}
    </Suspense>
  );
};

export default LazyRouteWrapper;
